import { Button, Container, Typography } from "@material-ui/core";
import React, { useState } from "react";
import useRecorder from "../../utils/useRecorder";
import MicIcon from "@material-ui/icons/Mic";
import StopIcon from "@material-ui/icons/Stop";

function TestAudio(props) {
	const [audioURL, isRecording, startRecording, stopRecording] = useRecorder();
	const [recorded, setRecorded] = useState(false);

	return (
		<Container
			style={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				height: "70vh",
				textAlign: "center",
			}}
		>
			<img src="/logo.png" className="avatar" alt="Josh Talks" />
			<div>
				<Typography variant="h6">
					Before, we begin your test.. lets test your audio!
				</Typography>
				<Typography variant="h6">Click on button below to start recording!</Typography>
			</div>
			{isRecording ? (
				<>
					<Typography variant="h4">Recording...</Typography>
					<div>
						<Button
							variant="contained"
							color="secondary"
							onClick={() => {
								stopRecording();
								setRecorded(true);
							}}
							startIcon={<StopIcon />}
						>
							Stop Recording
						</Button>
					</div>
				</>
			) : (
				<div>
					<Button
						variant="contained"
						color="primary"
						onClick={startRecording}
						startIcon={<MicIcon />}
					>
						Start Recording
					</Button>
				</div>
			)}
			{recorded ? (
				<>
					<div style={{ marginTop: 10 }}>
						<audio src={audioURL} controls />
					</div>
					<div>
						<Button
							variant="contained"
							className="start-test-btn"
							// onClick={}
							// disabled={}
						>
							{false ? "Starting test..." : "Attempt Test"}
						</Button>
					</div>
				</>
			) : (
				<></>
			)}
		</Container>
	);
}

export default TestAudio;
